/* eslint-disable */
(function() {
  var $ = require('jquery');
  var Handlebars = require('handlebars');
  require('./custom-handlebars-helpers');

  var $techLibList = $('.technical-widget.load-more');

  var catNames = '';
  var self = {
    skip: 0,
    take: 4,
  };

  $techLibList.each(function(i, item) {
    var $list = $(item);

    var currentDocID = $list.find('.docID input[type="hidden"]').val();
    var orderBy = $list.find('.orderby input[type="hidden"]').val();
    var showOnlyOnSearch = $list
      .find('.showOnlyOnSearch input[type="hidden"]')
      .val()
      .toLowerCase();
    var itemCont = $list.find('#' + $list.attr('id') + 'Replaced');
    var loadMore = $list.find('.load-more-btn');

    var templateElem = $list.find('#' + $list.attr('id') + 'Template');

    if (templateElem.length === 0) {
      return;
    }

    var source = templateElem.html();
    var template = Handlebars.compile(source);

    var searchInput = $('.tech-search input[type="text"]');
    var searchBtn = $('.tech-search input[type="submit"]');

    loadMore.click(function(e) {
      var $this = $(this);
      load(
        $this.data('skip'),
        $this.data('take'),
        catNames,
        itemCont,
        loadMore,
        template,
        orderBy,
        currentDocID,
        searchInput,
        false,
      );
      setTimeout(function() {}, 50);
      return false;
    });

    searchBtn.click(function(e) {
      e.preventDefault();
      loadMore.data('skip', 0);

      if (showOnlyOnSearch === 'true') {
        if (searchInput.val().length > 0) {
          $('.tech-wid-container').removeClass('hdn');
        } else {
          $('.tech-wid-container').addClass('hdn');
        }
      }

      load(
        0,
        loadMore.data('take'),
        catNames,
        itemCont,
        loadMore,
        template,
        orderBy,
        currentDocID,
        searchInput,
        true,
      );
      setTimeout(function() {}, 50);
      return false;
    });

    $list.find('.orig').hide();

    if (showOnlyOnSearch === 'false') {
      load(
        loadMore.data('skip'),
        loadMore.data('take'),
        catNames,
        itemCont,
        loadMore,
        template,
        orderBy,
        currentDocID,
        searchInput,
        false,
      );
    }
  });

  function load(
    Skip,
    Take,
    catNames,
    itemContainer,
    loadMore,
    template,
    orderBy,
    currentDocID,
    searchInput,
    ClearList,
  ) {
    var searchText = searchInput.val();

    $('#divPostsLoader').html('<img src="/sitefiles/images/loaded-icon.gif">');
    if (ClearList) {
      itemContainer.empty();
    }

    var tag = getParameterByName('tag');
    WebService.LoadTechLibDocs(
      Skip,
      Take,
      currentDocID,
      catNames,
      orderBy,
      tag,
      searchText,
      function(result) {
        itemContainer.append(template(result.Data));
        animateArticles(itemContainer);
        if (result.Data.AllLoaded === true) {
          loadMore.hide();
        } else {
          loadMore.show();
        }
      },
    );

    $('#divPostsLoader').empty();
    var newSkip = loadMore.data('skip') + Take;
    loadMore.data('skip', newSkip);
  }

  function animateArticles(itemContainer) {
    var lis = [];

    itemContainer.find('.tech-item').each(function() {
      if ($(this).css('opacity') === '0') {
        lis.push(this);
      }
    });

    var delay = 0;
    $(lis).each(function() {
      $(this)
        .delay(delay)
        .animate(
          {
            opacity: 1,
          },
          500,
        );
      delay += 100;
    });
  }

  function getParameterByName(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  return self;
})();
